export default {
  '测试结果详情':'测试结果详情',
  '测试结果列表':'测试结果列表',
  '请输入学生姓名、学籍号':'请输入学生姓名、学籍号',
  '同步组织测试':'同步组织测试',
  '批量删除':'批量删除',
  '测评报告':'测评报告',
  '同步成功后，将覆盖展示最新的一次成绩':'同步成功后，将覆盖展示最新的一次成绩',
  
  '学年':'学年',
  '年级':'年级',
  '班级编号':'班级编号',
  '班级名称':'班级名称',

  'BMI':'BMI',
  '身高(cm)':'身高(cm)',
  '体重(KG)':'体重(KG)',
  '肺活量(ml)':'肺活量(ml)',
  '50米跑(秒)':'50米跑(秒)',
  "800米跑(分秒)":"800米跑(分'秒)",
  "1000米跑(分秒)":"1000米跑(分'秒)",
  '坐位体前屈(cm)':'坐位体前屈(cm)',
  '一分钟跳绳(次)':'一分钟跳绳(次)',
  '一分钟仰卧起坐(次)':'一分钟仰卧起坐(次)',
  "50米X8往返跑(分秒)":"50米X8往返跑(分'秒)",
  '立定跳远(cm)':'立定跳远(cm)',
  '引体向上(次)':'引体向上(次)',
  '免检原因':'免检原因',

  '同步中':'同步中',
  '请选择组织测试计划':'请选择组织测试计划',
  '请选择记录':'请选择记录',
  '是否确认删除勾选学生测试结果？':'是否确认删除勾选学生测试结果？',
  '删除后不可恢复，确认删除吗？':'删除后不可恢复，确认删除吗？',
  '删除成功！':'删除成功！',
  '是否确认删除学生{name}测试结果？':'是否确认删除学生{name}测试结果？',
  
  '新增计划':'新增计划',
  '详情':'详情',
  '导入':'导入',
  '同步':'同步',
  '新增体质健康监测':'新增体质健康监测',
  '选择学年':'选择学年',
  '同步组织测试':'同步组织测试',
  '同步成功后，将覆盖展示最新的一次成绩':'同步成功后，将覆盖展示最新的一次成绩',
  
  '参测人数':'参测人数',
  '平均分':'平均分',
  '优秀':'优秀',
  '良好':'良好',
  '及格':'及格',
  '不及格':'不及格',
  '操作账号':'操作账号',
  '导入中，不允许重复同步':'导入中，不允许重复同步',
  '同步成功！':'同步成功！',
  '同步中，不允许重复导入':'同步中，不允许重复导入',
  '新建成功':'新建成功',
  '导入中，请勿删除':'导入中，请勿删除',
  '同步中，请勿删除':'同步中，请勿删除',
  '是否确认删除{acayearSemCodea}-{acayearSemCodeb} {acayearSemName}测试结果?':'是否确认删除{acayearSemCodea}-{acayearSemCodeb} {acayearSemName}测试结果?',

  '学生体质健康测试报告单':'学生体质健康测试报告单',
  '姓名：':'姓名：',
  '班级：':'班级：',
  '学籍号：':'学籍号：',
  '性别：':'性别：',
  '学校：':'学校：',
  '单项指标':'单项指标',
  '年级平均':'年级平均',
  '体重指数（BMI）':'体重指数（BMI）',
  '（单位：千克/米²）':'（单位：千克/米²）',
  '肺活量':'肺活量',
  '（单位：毫升）':'（单位：毫升）',
  '50米跑':'50米跑',
  '（单位：秒）':'（单位：秒）',

  '坐位体前屈':'坐位体前屈',
  '（单位：厘米）':'（单位：厘米）',
  '一分钟跳绳':'一分钟跳绳',
  '（单位：次）':'（单位：次）',
  '一分钟仰卧起坐':'一分钟仰卧起坐',
  '50米×8往返跑':'50米×8往返跑',
  '（单位：分’秒）':'（单位：分’秒）',
  '立定跳远':'立定跳远',
  '引体向上（男）':'引体向上（男）',
  '1000米跑（男）':'1000米跑（男）',
  '一分钟仰卧起坐（女）':'一分钟仰卧起坐（女）',
  '800米跑（女）':'800米跑（女）',
  '标准分':'标准分',
  '加分指标':'加分指标',
  '1分钟跳绳':'1分钟跳绳',

  '总分':'总分',
  '年级平均':'年级平均',
  '等级':'等级',
  '总评：':'总评：',
  '1、总分由标准分与附加分之和构成，满分为120分。标准分由各单项指标得分与权重乘积之和组成，满分为100分。附加分根据实测成绩确定，即对成绩超过100分的加分指标进行加分，满分为20分；小学的加分指标为1分钟跳绳，加分幅度为20分；初中、高中和大学的加分指标为男生引体向上和1000米跑，女生1分钟仰卧起坐和800米跑，各指标加分幅度均为10分。':'1、总分由标准分与附加分之和构成，满分为120分。标准分由各单项指标得分与权重乘积之和组成，满分为100分。附加分根据实测成绩确定，即对成绩超过100分的加分指标进行加分，满分为20分；小学的加分指标为1分钟跳绳，加分幅度为20分；初中、高中和大学的加分指标为男生引体向上和1000米跑，女生1分钟仰卧起坐和800米跑，各指标加分幅度均为10分。',
  '等级判定':'2、等级判定：90.0分及以上为优秀，80.0～89.9分为良好，60.0～79.9分为及格，59.9分及以下为不及格。',

  '体质健康监测模板':'体质健康监测模板.xlsx',
  '测试成绩导出xlsx':'测试成绩导出.xlsx',

  '选择组织测试':'选择组织测试',
  '请选择组织测试':'请选择组织测试',
  '同步方式':'同步方式',
  '覆盖原成绩':'覆盖原成绩',
  '择优更新':'择优更新',
  '本次同步的项目将覆盖原有成绩':'本次同步的项目将覆盖原有成绩',
  '本次同步的项目与原有成绩择优后展示':'本次同步的项目与原有成绩择优后展示',
  '正在同步中，请勿关闭本页面':'正在同步中，请勿关闭本页面',
  '同步完成':'同步完成',
  '同步完成但有异常数据':'同步完成但有异常数据',
  '取消同步':'取消同步',
  '确定要取消同步吗':'确定要取消同步吗',
  '同步异常数据':'同步异常数据',
  '取消同步成功':'取消同步成功',
  '免考学生暂无报告单':'免考学生暂无报告单',
}